import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const DogPopup = ({ isVisible, onClose, message }) => {
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, x: -100, y: 50 }}
          animate={{ opacity: 1, x: 0, y: 0 }}
          exit={{ opacity: 0, x: -100, y: 50 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="fixed bottom-20 left-6 z-50 pointer-events-none"
        >
          {/* Speech Bubble */}
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2, duration: 0.3 }}
            className="relative mb-4 ml-8"
          >
            <div className="bg-white rounded-2xl px-4 py-3 shadow-lg border-2 border-gray-200 max-w-xs">
              <p className="text-sm font-medium text-gray-800 text-center">
                {message || "I won't be in the call, but I'm always ready to play!"}
              </p>
              {/* Speech bubble tail */}
              <div className="absolute bottom-[-10px] left-8 w-4 h-4 bg-white border-r-2 border-b-2 border-gray-200 transform rotate-45"></div>
            </div>
          </motion.div>
          
          {/* Dog Image */}
          <motion.div
            initial={{ scale: 0, rotate: 10 }}
            animate={{ scale: 1, rotate: 0 }}
            transition={{ delay: 0.1, duration: 0.4 }}
            className="relative"
          >
            <div className="w-24 h-24 rounded-full overflow-hidden border-4 border-white shadow-xl">
              <img
                src="https://images.unsplash.com/photo-1558788353-f76d92427f16"
                alt="Friendly dog"
                className="w-full h-full object-cover"
              />
            </div>
            
            {/* Cute paw prints animation */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: [0, 1, 0] }}
              transition={{ delay: 1, duration: 2, repeat: 1 }}
              className="absolute -top-2 -right-2"
            >
              <span className="text-2xl">🐾</span>
            </motion.div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default DogPopup;